// Build-Zeit wird beim tatsächlichen craco-Build/-Start injiziert (siehe craco.config.js).
/* global __APP_BUILD_TIME__ */
export const BUILD_TIME = typeof __APP_BUILD_TIME__ !== "undefined" ? __APP_BUILD_TIME__ : "";
